var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"broadcast-wrapper",class:_vm.state,on:{"click":_vm.toggleBroadCast}})
}
var staticRenderFns = []

export { render, staticRenderFns }